<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-8">
        <Heading title="Analytics" subTitle="Superchargify automagically reads analytics settings from your store. If we can't find any settings, you can manually enter it here." />
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Shopify Analytics</h2>
        <p class="font-weight-normal">AMP pageviews will be recorded to your Shopify Analytics account.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div class="media media-list-item text-left align-items-center">
              <IconCheck height="22" class="active mr-2" />
              <div class="media-body">
                <p class="m-0 font-weight-normal">Shopify Analytics is enabled by default for your AMP pages.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Google Analytics</h2>
        <p class="font-weight-normal">AMP pageviews &amp; user interactions will be recorded to your Google Analytics account.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div class="form-group mb-0">
              <label for="googleAnalyticsId">Google Analytics ID</label>
              <input type="text" class="form-control" id="googleAnalyticsId" v-model="analytics__ga" placeholder="UA-XXXXXXXX-X">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6">Facebook Analytics</h2>
        <p class="font-weight-normal">AMP pageviews &amp; user interactions will be recorded to your Facebook Analytics account.</p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div class="form-group mb-0">
              <label for="facebookPixelId">Facebook Pixel ID</label>
              <input type="text" class="form-control" id="facebookPixelId" v-model="analytics__fb" placeholder="XXXXXXXXXXXXXXX">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-settings">
      <div class="col-md-4">
        <h2 class="h6 heading-badge">
          <span>Google Tag Manager</span>
          <UpgradeBadge targetPlan="basic" class="ml-2" noFreeUsers />
        </h2>
        <p class="font-weight-normal">Record custom events on AMP pages usinng Google Tag Manager.</p>
        <p class="font-weight-normal mb-0">
          <ExternalLink href="https://www.superchargify.com/blog/gtm-with-amp-on-shopify" text="Setup instructions" />
        </p>
      </div>
      <div class="col-md-8">
        <div class="card bs">
          <div class="card-body">
            <div class="form-group mb-0">
              <label for="googleTagManager">
                Google Tag Manager (For advance analytics)
              </label>
              <input type="text" class="form-control" id="googleTagManager" v-model="analytics__gtm" placeholder="GTM-XXXXXX">
            </div>
          </div>
        </div>
      </div>
    </div>

    <SaveButton :hasChanged="hasChanged" @click="saveMaster" bar discard class="text-right" />

    <LeaveReview class="mt-45" alert />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import watchForChange from '@/mixins/watchForChange'
import mapMultiComputed from '@/mixins/mapMultiComputed'
import UpgradeBadge from '@/components/UpgradeBadge'
import LeaveReview from '@/components/LeaveReview'
import routeReady from '@/mixins/routeReady'

export default {
  mixins: [
    routeReady,
    watchForChange(),
    mapMultiComputed('settings', [
      'analytics.fb',
      'analytics.ga',
      'analytics.gtm'
    ])
  ],
  components: {
    UpgradeBadge,
    LeaveReview
  },
  methods: mapActions([ 'saveMaster' ])
}
</script>
